module.exports = __webpack_public_path__ + "static/media/busm-256.277a944d.png";